<template>
  <div class="flowy-block-container">
    <v-card elevation="0" class="flow-card">
      <v-list class="flow-list" elevation="0">
        <v-list-item class="pl-3 pr-4 flow-list">
          <v-list-item-action class="ml-0 mr-0">
            <flowy-drag-handle class="flow-action">
              <v-btn class="flow-btn" color="transparent" small text>
              </v-btn>
            </flowy-drag-handle>
          </v-list-item-action>
          <v-list-item-action class="flow-icon">
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-list-item-content>
        <v-list-item-title class="drag-title">
          {{ title }}
        </v-list-item-title>
      </v-list-item-content>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "FlowchartBlock",
  data() {
    return {
      text: 'This is component A',
      icon: 'mdi-crosshairs-gps'
    }
  },
  props: ['remove', 'node', 'title', 'description', 'type'],
  created() {
    if (this.type) {
      if (this.type == 'submission')
        this.icon = 'mdi-crosshairs-gps';
      else if (this.type == 'pass')
        this.icon = 'mdi-arrow-decision-outline';
      else if (this.type == 'mount')
        this.icon = 'mdi-arrow-collapse-down';
      else if (this.type == 'side-control')
        this.icon = 'mdi-selection-ellipse-arrow-inside';
      else if (this.type == 'sweep')
        this.icon = 'mdi-cached';
      else if (this.type == 'back')
        this.icon = 'mdi-arrange-send-backward';
      else if (this.type == 'takedown')
        this.icon = 'mdi-arrow-down-right';
      else if (this.type == 'transition')
        this.icon = 'mdi-transition-masked';
      else if (this.type == 'guard')
        this.icon = 'mdi-shield-half-full';
      else if (this.type == 'standup')
        this.icon = 'mdi-arrange-send-to-back';
      else if (this.type == 'escape')
        this.icon = 'mdi-lock-open-check-outline';
      else if (this.type == 'generic')
        this.icon = 'mdi-hexagon-multiple-outline';
    }
  }
};
</script>
<style scoped>
.flow-action {
  margin-left: -14px;
  margin-right: -14px;
  margin-bottom: -1px;
  z-index: 100;
}


.flow-btn {
  margin-left: 0px;
  margin-right: 0px;
  padding: 0px;
  width: 20px;
  height: 20px;
}

.flow-card {

  max-width: 50px;
  max-height: 50px;
}

.flow-icon {
  margin-left: 0px;
  margin-right: 0px;
  position: relative;
  top: -60px;
  right: 15px;
  color: #675BF0 !important;
}

.flowy-block {
  max-width: 100px;
  background-color: #8866ff30 !important;
  border: 1px solid #8866ff !important;
}

.flowy-block-container {
  margin-bottom: 10rem;
  margin-right: 12px;
}

.flow-list {
  display: block;
  max-height: 50px;
  padding: 0px;
  border-radius: 50px;
  background-color: #8866ff10 !important;

}

.v-card>*:first-child:not(.v-btn):not(.v-chip):not(.v-avatar) {
  border-top-left-radius: 50px !important;
  border-top-right-radius: 50px !important;
}


.flow-icon .theme--dark.v-icon {
  color: #8866ff !important;
}

.flow-icon .theme--light.v-icon {
  color: #8866ff !important;
}


.drag-title {
  font-size: 10px;
  font-weight: 500;
  color: #88888c;
  text-align: center;
}
</style>